<template>
  <div class="row q-col-gutter-md justify-center">
    <q-select
      v-model="inventoryItemAdjustment.inventoryItemUnit"
      class="no-select col-10"
      :hide-bottom-space="dense"
      label="Unit"
      option-label="description"
      :options="unitOptions"
      :readonly="!!inventoryItemAdjustment.committedAt"
      :rules="[val => !!val || 'Field is required']"
      bottom-slots
      :dense="dense"
    />
    <div
      class="col-2 column justify-center items-center"
      :class="{ 'q-pt-none q-pl-sm': !dense }"
    >
      <q-btn
        v-if="showCalculatorButton"
        icon="fas fa-calculator"
        size="md"
        round
        flat
        @click="showDialog = true"
      />
    </div>
    <q-dialog
      v-model="showDialog"
    >
      <q-card
        v-if="inventoryItemAdjustment.inventoryItem"
        style="width: 500px;"
      >
        <q-list
          bordered
          separator
        >
          <q-item
            v-for="unitOption in unitOptions"
            :key="unitOption.id"
            class="q-py-md q-pr-none"
          >
            <q-item-section>
              <q-item-label class="row q-col-gutter-md items-center">
                <div class="col-6 text-h6">
                  {{ unitOption.description }}
                </div>
                <q-input
                  :model-value="inventoryItemAdjustment.unitQuantityConfig[unitOption.id]"
                  type="number"
                  :readonly="inventoryItemAdjustment.readonly"
                  class="col-6"
                  hide-bottom-space
                  label="Unit Qty"
                  :rules="inventoryItemAdjustment.unitQuantityRulesForCalculator"
                  step="1"
                  min="0"
                  bottom-slots
                  dense
                  @update:model-value="qty => setUnitQuantity(unitOption.id, qty)"
                />
              </q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import InventoryItemAdjustment from 'src/models/inventory-item/InventoryItemAdjustment'

export default {
  name: 'InventoryItemAdjustmentUnitSelect',
  props: {
    inventoryItemAdjustment: {
      type: InventoryItemAdjustment,
      required: true
    },
    dense: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      showDialog: false
    }
  },
  computed: {
    unitOptions () {
      return _.sortBy(this.inventoryItemAdjustment.inventoryItem?.inventoryItemUnits.data, 'baseQuantity') || []
    },
    showCalculatorButton () {
      if (!this.inventoryItemAdjustment.inventoryItem || !this.inventoryItemAdjustment.inventoryItemUnit) return false

      if (this.inventoryItemAdjustment.inventoryItem.inventoryItemUnits.data.length < 2) return false

      return this.inventoryItemAdjustment.inventoryItem.baseInventoryItemUnit?.id === this.inventoryItemAdjustment.inventoryItemUnit.id
    }
  },
  methods: {
    setUnitQuantity (unitId, qty) {
      this.inventoryItemAdjustment.unitQuantityConfig = {
        ...this.inventoryItemAdjustment.unitQuantityConfig,
        [unitId]: Number(qty)
      }
    }
  }
}
</script>
